import $ from 'jquery'

function init () {
  let elements = $('.comparison-chart-module')
  $.each(elements, function () {
      hideScrollHint()
    }
  )
}

function hideScrollHint () {
  $('.comparison-chart-module').scroll(function () {

    var offset = $(this).find('.compare-table').offset(),
      scrollGradient = $(this).find('.scroll-gradient'),
      scrollWrapper = $(this).find('.scroll-wrapper')

    if (offset.left < 0) {
      scrollGradient.addClass('hidden')
      scrollWrapper.addClass('hidden')
    } else {
      scrollGradient.removeClass('hidden')
      scrollWrapper.removeClass('hidden')
    }
  })
}

export default {
  init
}
